/**
 * Export the Vue plugin install method
 * @param {object} Vue Vue instance
 */
export const install = (Vue) => {

	/**
	 * Remember form object by storing it into sessionStorage
	 * @param {string} key
	 * @param {string} mutation
	 * @param {object} payload
	 */
	Vue.prototype.rememberForm = function(key, mutation, payload) {
		if (this.sessionStorage) {
			this.sessionStorage.set(key, {
				mutation,
				payload
			});
			this.$store.commit(mutation, payload);
		}
	};

	/**
	 * Restore form object and update the Vuex store
	 * @param {string} key
	 */
	Vue.prototype.restoreForm = function(key) {
		if (this.sessionStorage) {
			const storedData = this.sessionStorage.get(key);
			if (storedData) {
				this.$store.commit(storedData.mutation, storedData.payload);
			}
		}
	};

	/**
	 * Forget form object
	 * @param {string} key
	 */
	Vue.prototype.forgetForm = function(key) {
		if (this.sessionStorage) {
			this.sessionStorage.remove(key);
		}
	};
};

export default {
	install
};
